<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <v-card v-if="$store.getters.getLanguageList">     
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer('user')}}</div>
            <div v-if="needInit">{{initData()}}</div> 
            <div v-if="myContent">
                <div v-html="myContent.content"></div>
                    <div v-for="(item, index) in myContent.answer_list" :key="index" >
                        <v-checkbox v-model="myAnswers" :label="item.answer" :value="index" :color="(getStyle(index)).color" @change="resetEvaluatedData"></v-checkbox>
                        <p v-if="myAnswers.indexOf(index) > -1 && showFeedback" v-bind:style="getStyle(index)">{{item.feedback}}</p>
                    </div>                                 
            </div>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                myAnswers : [],
                myGlobals: null,
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                showFeedback: false,
                answersBackup: []

        }
    },
    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getTryAgainEvent'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        initData() {
            this.needInit = false         
            this.$store.commit('setFeedback', null)   
            this.myContent = (this.dcontent.data.content)
            this.myGlobals = (this.dcontent.data.globals)

            // for multilanguage identification of bad answer
            this.answersBackup = []
            for(let i=0; i < this.myContent.answer_list.length; i++) {
                this.answersBackup.push(this.myContent.answer_list[i].answer)
            }

            // shuffle
            for(let i=0; i < this.myContent.answer_list.length; i++) {
                const rand = Math.floor(Math.random() * this.myContent.answer_list.length);
                [this.myContent.answer_list[i], this.myContent.answer_list[rand]] = [this.myContent.answer_list[rand], this.myContent.answer_list[i]];
                [this.myGlobals.ratings[i], this.myGlobals.ratings[rand]] = [this.myGlobals.ratings[rand], this.myGlobals.ratings[i]];
            }                        
        },
        checkAnswer(owner) {
            this.$store.commit('setCheckAnswerEvent', false)

            var questionResult = 0
            for(let i = 0; i < this.myContent.answer_list.length; i++) {
                if (this.myAnswers.indexOf(i) > -1)  questionResult += this.myGlobals.ratings[i]
            }

            // global indexes for language independent data collection
            var answList = []
            for(let i = 0; i < this.myAnswers.length; i++) {
                answList.push(this.answersBackup.indexOf(this.myContent.answer_list[this.myAnswers[i]].answer))
            }

            this.showFeedback = true
            questionResult = Math.max(Math.floor(questionResult + 0.5),0)

            // if (questionResult < 100) 
            this.$store.commit('setTryAgainEvent',true)

            this.$store.commit('setAnswer',this.describeAnswer(owner,questionResult,answList))
            this.$store.commit('setCheckRatingEvent',true)
        },
        describeAnswer(user, score, lst) {
            return {
                solver: user,
                type: 4,
                answer: '',
                answer_index: lst, 
                rating: score
            }
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
            this.myAnswers = []
            for(var i = 0; i < this.myGlobals.ratings.length; i++) {
                if (this.myGlobals.ratings[i] > 0) {
                    this.myAnswers.push(i)
                }
            }       
            this.checkAnswer('system')     
        },
        getStyle(index) {
            if (!this.showFeedback) return { color: "black"}
            if (this.myAnswers.indexOf(index) == -1) return { color: "black"}
            if (this.myGlobals.ratings[index] > 0) return { color: "green"}
            return { color: "red"}
        },
        resetEvaluatedData() {
            this.showFeedback = false
            this.styleObject.color = 'black'
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>
</style>